import { render, staticRenderFns } from "./safeDepositHistory.vue?vue&type=template&id=7b9a6bea"
import script from "./safeDepositHistory.vue?vue&type=script&lang=js"
export * from "./safeDepositHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports